enum EPhoneAreaCode {
  SG = '+65',
  HK = '+852',
  MY = '+60',
  ID = '+62',
  TH = '+66',
  TW = '+886',
  PH = '+63',
}
export enum ECountryCode {
  SG = 'SG',
  HK = 'HK',
  MY = 'MY',
  ID = 'ID',
  TH = 'TH',
  TW = 'TW',
  PH = 'PH',
}
enum ECurrency {
  SG = 'SGD',
  HK = 'HKD',
  MY = 'MYR',
  ID = 'IDR',
  TH = 'THB',
  TW = 'TWD',
  PH = 'PHP',
}

enum ContactEmail {
  SG = 'merchant@atome.sg',
  HK = 'merchant@atome.hk',
  MY = 'merchant@atome.my',
  ID = 'merchant@atome.id',
  TH = 'merchant.th@atomefin.com',
  TW = 'merchant@atome.tw',
  PH = 'merchant@atome.ph',
}

enum TermsServiceUrl {
  SG = 'https://www.atome.sg/terms-of-service',
  HK = 'https://www.atome.hk/terms-of-service',
  MY = 'https://www.atome.my/terms-of-service',
  ID = 'https://www.atome.id/terms-of-service',
  TH = 'https://www.atometh.com/terms-of-service',
  TW = 'https://www.atome.tw/terms-of-service',
  PH = 'https://www.atome.ph/terms-of-service',
}

enum MinAmount {
  SG = 0.01,
  HK = 0.01,
  MY = 0.01,
  ID = 1,
  TW = 1,
  TH = 0.01,
  PH = 0.01,
}

enum ToFixedNum {
  SG = 2,
  HK = 2,
  MY = 2,
  ID = 0,
  TH = 2,
  TW = 0,
  PH = 2,
}

const MoneyRegTest = {
  SG: /^(\d*)\.?(\d){0,2}$/,
  HK: /^(\d*)\.?(\d){0,2}$/,
  MY: /^(\d*)\.?(\d){0,2}$/,
  ID: /^(\d*)$/,
  TH: /^(\d*)\.?(\d){0,2}$/,
  TW: /^(\d*)$/,
  PH: /^(\d*)\.?(\d){0,2}$/,
};

let countryCode: ECountryCode;
if (location.host.includes('hk')) {
  countryCode = ECountryCode.HK;
} else if (location.host.includes('my')) {
  countryCode = ECountryCode.MY;
} else if (location.host.includes('id')) {
  countryCode = ECountryCode.ID;
} else if (location.host.includes('th')) {
  countryCode = ECountryCode.TH;
} else if (location.host.includes('tw')) {
  countryCode = ECountryCode.TW;
} else if (location.host.includes('ph')) {
  countryCode = ECountryCode.PH;
} else {
  countryCode = ECountryCode.SG;
}
export const RegionTimeZone = {
  SG: 'Asia/Singapore',
  HK: 'Asia/Hong_Kong',
  MY: 'Asia/Kuala_Lumpur',
  ID: 'Asia/Jakarta',
  TH: 'Asia/Bangkok',
  VN: 'Asia/Ho_Chi_Minh',
  TW: 'Asia/Tai_Wan',
  PH: 'Asia/Manila',
};

const timeZone = RegionTimeZone[countryCode];
const phoneAreaCode: EPhoneAreaCode = EPhoneAreaCode[countryCode];
const currency: ECurrency = ECurrency[countryCode];
const contactEmail: ContactEmail = ContactEmail[countryCode];
const termsServiceUrl: TermsServiceUrl = TermsServiceUrl[countryCode];
const minAmount: MinAmount = MinAmount[countryCode];
const moneyRegTest = MoneyRegTest[countryCode];
const toFixedNum: ToFixedNum = ToFixedNum[countryCode];

export {
  phoneAreaCode,
  countryCode,
  currency,
  contactEmail,
  termsServiceUrl,
  minAmount,
  moneyRegTest,
  toFixedNum,
  timeZone,
};
